import React from 'react';
import classNames from 'classnames';

interface IOverlayProps {
  position?: 'absolute' | 'relative' | 'fixed';
  className?: string;
}

const Overlay: React.FC<React.PropsWithChildren<IOverlayProps>> = ({children, position = 'absolute', className}) => {
  return <div className={classNames(className, 'top-0 left-0 w-full h-full', {
    'fixed': position === 'fixed',
    'absolute': position === 'absolute',
    'relative': position === 'relative',
  })}>{children}</div>;
};
export default Overlay;
